export const locale = {
  lang: 'vn',
  data: {
    CODEMESSAGE: {
      200: 'Máy chủ đã trả về thành công dữ liệu được yêu cầu.',
      201: 'Dữ liệu mới hoặc đã sửa đổi thành công.',
      202: 'Một yêu cầu đã vào hàng đợi nền (tác vụ không đồng bộ).',
      204: 'Dữ liệu đã được xóa thành công.',
      400: 'Đã xảy ra lỗi trong yêu cầu được gửi và máy chủ không tạo hoặc sửa đổi dữ liệu.',
      401: 'Người dùng không có quyền (mã thông báo, tên người dùng, mật khẩu sai).',
      403: 'Người dùng được ủy quyền, nhưng truy cập bị cấm.',
      404: 'Yêu cầu được gửi là một bản ghi không tồn tại và máy chủ không hoạt động.',
      406: 'Định dạng được yêu cầu không khả dụng.',
      410: 'Tài nguyên được yêu cầu đã bị xóa vĩnh viễn và sẽ không còn nữa.',
      422: 'Khi tạo một đối tượng, đã xảy ra lỗi xác thực.',
      500: 'Đã xảy ra lỗi trong máy chủ, vui lòng kiểm tra máy chủ',
      502: 'Lỗi cổng vào.',
      503: 'Dịch vụ không khả dụng và máy chủ tạm thời bị quá tải hoặc được bảo trì.',
      504: 'Cổng vào đã hết thời gian chờ.',
    },
  },
};
